import { MdOutlineCorporateFare } from "react-icons/md";
import { RiMentalHealthFill } from 'react-icons/ri';
import { HiUserGroup } from 'react-icons/hi';
import { MdManageAccounts } from 'react-icons/md';
import { GiHypodermicTest } from 'react-icons/gi';
import { ShieldUser } from 'lucide-react';

export const sidebarItems = [
  {
    type: 'link',
    to: '/admin/admin_user/corporate',
    icon: MdOutlineCorporateFare,
    text: 'Corporate',
    pageId: 1,
  },
  {
    type: 'link',
    to: '/admin/admin_user/hr',
    icon: MdManageAccounts,
    text: 'Admin',
    pageId: 8,
  },
  {
    type: 'menu',
    icon: HiUserGroup,
    text: 'Member',
    paths: [
      '/admin/admin_user/uploadeemployee',
      '/admin/admin_user/employee',
      '/admin/export',
      '/admin/admin_user/family_member',
    ],
    subItems: [
      { to: '/admin/admin_user/uploadeemployee', text: 'Create Member', pageId: 2 },
      { to: '/admin/admin_user/employee', text: 'Member List', pageId: 9 },
      { to: '/admin/export', text: 'Export', pageId: 3 },
      { to: '/admin/admin_user/family_member', text: 'Family Member', pageId: 10 },
    ],
  },
  {
    type: 'link',
    to: '/admin/admin_user/healthtips',
    icon: RiMentalHealthFill,
    text: 'Health Tips',
    pageId: 4,
  },
  {
    type: 'link',
    to: '/admin/admin_user/labtest',
    icon: GiHypodermicTest,
    text: 'Book A Lab Test',
    pageId: 11,
  },
  {
    type: 'menu',
    icon: HiUserGroup,
    text: 'Partners',
    paths: [
      '/admin/admin_user/master',
      '/admin/admin_user/vfs_uk',
      '/admin/admin_user/credit_note',
      '/admin/admin_user/payment_failed',
      '/admin/admin_user/bls',
      '/admin/admin_user/vfs_team_members',
    ],
    subItems: [
      { to: '/admin/admin_user/bls', text: 'BLS', pageId: 5 },
      { to: '/admin/admin_user/master', text: 'Onevasco', pageId: 12 },
      {
        type: 'submenu',
        text: 'VFS UK LP',
        paths: [
          '/admin/admin_user/vfs_uk',
          '/admin/admin_user/credit_note',
          '/admin/admin_user/payment_failed',
          '/admin/admin_user/vfs_team_members',
        ],
        subItems: [
          { to: '/admin/admin_user/vfs_uk', text: 'Members', pageId: 6 },
          { to: '/admin/admin_user/credit_note', text: 'Refund', pageId: 13 },
          { to: '/admin/admin_user/payment_failed', text: 'Payment Failed',pageId: 14 }, 
          { to: '/admin/admin_user/vfs_team_members', text: 'Team Members', pageId: 7 },
        ],
      },
    ],
  },
  {
    type: 'link',
    to: '/admin/admin_user/team_members',
    icon: ShieldUser,
    text: 'Team Members',
    pageId: 0,
  },
];
